/* =============================================================
 * import
 * ========================================================== */
import {config} from "../config";
import barba from '@barba/core';
// import barbaPrefetch from '@barba/prefetch'; // ビューポートに入るすべての対象リンクをプリフェッチする
import {isMobile} from "../utils/utils";
import {customPreventCheck, resetAnyFunc, gaSend, replaceHeadTags} from "./options";
import {appInit} from "../app";
import {initScrollSmoother, resetSmoothScrollSmoother} from "../modules/scrollSmoother";
// import {scrollResetPosition} from "../modules/scrollResetPosition";

// 各ページ固有のスクリプト
import {routeCommonBefore, routeCommonAfter} from "../route/common";
import top from "../route/top";
import news from "../route/news";
import brand from "../route/brand";
import {setForm, resetForm} from "../route/form";

// アニメーション
import {fade} from "./transition/fade";

/* =============================================================
 * variables
 * ========================================================== */
// const $body = document.body;
// const $header = document.getElementById('header');

const domain = document.domain;
const domainProd = 'sypress.jp'; // TODO プロジェクトの本番環境ドメインを指定
const gaTagType = 'ga4'; // ga4 || gtm  // TODO GTMを使う場合は、GTM側のSPA設定を有効にするだけでOK。gaTagTypeをgtmにすることでJS側でのイベント送信を無効化できる。
const gaTagId = "G-Z29QB296XP";  // TODO プロジェクトのGTMアカウントを指定



// GA4設定
// ga4の自動ページ遷移イベントの送信を無効化（barbaの遷移イベントで手動で送信）
if (domain === domainProd && gaTagType === 'ga4' && gaTagId !== '') {
  gtag('config', gaTagId, { // eslint-disable-line no-undef
    send_page_view: false,
  });
}


// barba初期設定
export const initBarba = () => {

  // barba.use(barbaPrefetch); // viewportに入るすべての対象リンクをプリフェッチする。スクロールのたびに負荷がかかるのでスクロールアニメーションとの併用には要注意（カクカクしがち）

  barba.init({
    debug: false,
    // logLevel: 'debug',
    schema: {
      prefix: 'data-trans',
      wrapper: 'wrapper',
      container: 'container',
      namespace: 'namespace',
    },

    // ページ遷移を防ぐか否かの判断
    prevent: ({el, event, href}) => customPreventCheck(el, event, href),

    // キャッシュを無効にするページ指定
    cacheIgnore: [
      '/contact/',
      '/request/',
    ],

    // ページ固有のスクリプトを管理
    // 利用可能なフック：beforeLeave, afterLeave, beforeEnter, afterEnter
    views: [
      {
        namespace: 'home',
        afterEnter(data) { // eslint-disable-line @typescript-eslint/no-unused-vars
          top(data);
        },
      },
      {
        namespace: 'news',
        afterEnter(data) { // eslint-disable-line @typescript-eslint/no-unused-vars
          news();
        },
      },
      {
        namespace: 'brand',
        afterEnter(data) { // eslint-disable-line @typescript-eslint/no-unused-vars
          brand(data);
        },
      },
      {
        namespace: 'contact',
        beforeEnter() {
          setForm();
        },
      },
    ],

    // 遷移時のアニメーションを細かく管理
    // 利用可能なフック：beforeOnce, once, afterOnce, before, beforeLeave, leave, afterLeave, beforeEnter, enter, afterEnter, after
    // https://barba.js.org/docs/advanced/hooks/#Base-hooks
    transitions: [
      {
        // sync: true ,
        name: 'global-transitions',
        // sync: true, // 同時実行モードを有効化
        async leave(data) { // eslint-disable-line @typescript-eslint/no-unused-vars
          // ページ離脱時のアニメーション
          await fade.leave(data);
        },
        async enter(data) { // eslint-disable-line @typescript-eslint/no-unused-vars
          // ページ表示時のアニメーション
          await fade.enter(data);
        },
      },
    ],
  });


  // 遷移前後の共通設定
  // 利用可能なフック：beforeOnce, once, afterOnce, before, beforeLeave, leave, afterLeave, beforeEnter, enter, afterEnter, after
  // 次ページのDOMの用意が整い、leave transition遷移アニメーションが実行された後（ランディング時には読み込まれない）
  barba.hooks.afterLeave((data) => {
    resetAnyFunc();
    routeCommonBefore(data);
  });

  // 次ページへの遷移アニメーションに入る手前
  barba.hooks.beforeEnter((data) => {
    // 慣性スクロールを遷移後コンテンツで初期化
    if (config.enableScrollSmoother && !isMobile()) {
      initScrollSmoother(data);
    }
    // scrollResetPosition(data); // スクロール位置を適切な位置にセット（enterアニメーション内に移動）
  });

  // 次ページへの遷移が完了し、遷移アニメーションが終了した後（ランディング時にも読み込まれる）
  barba.hooks.afterEnter((data) => {
    routeCommonAfter(data);
    resetForm(data); // reCAPTCHAタグの削除など
  });


  // 全プロセスが完了した後（ランディング時には読み込まれない）
  barba.hooks.after((data) => {
    replaceHeadTags(data.next);  // headタグの動的置換
    gaSend(gaTagType, domain, domainProd);  // GA4の動的読み込み
    appInit(); // ページ遷移の度に実行

    // smoothScrubを初期化（アンカーリンク時のバグ調整用）
    if (config.enableScrollSmoother && !isMobile()) {
      resetSmoothScrollSmoother();
    }
  });


};
